// Hook pobierający pozycje zamówienia klienta handlowca (tradera).
// GET /api/ui/sales-crm/clients/{clientId}/orders/{orderId}/positions

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  ISearchRequest
} from 'api/types';
import { IOrderPositionListItem } from 'api/endpoints/useGetOrderPositions';

export type IRequest = IPaginationRequest & ISearchRequest;
type IResponse = IPaginationResponse<IOrderPositionListItem>;

const getSalesCrmClientOrderPositions = (
  clientId: number,
  orderId: number,
  params?: IRequest
): Promise<IResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/orders/${orderId}/positions`, { params });

export const useGetSalesCrmClientOrderPositions = (
  clientId: number,
  orderId: number,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['sales-crm-client-order-positions', clientId, orderId, params],
    () => getSalesCrmClientOrderPositions(clientId, orderId, params),
    options
  );
